export default {
  action_cable: {
    save_segment_message:
      'Save the following segment and update the name to %{name}: %{data}',
    queue_timeout_error:
      'Connection timeout. Your message could not be sent. Please try again.',
    max_retries_error:
      'Failed to send message after multiple attempts. Please check your connection and try again.',
  },
  header: {
    ai_label: 'AI',
    cancel: 'Cancel',
  },
  prompt_input: {
    default_submit_text: 'Submit',
    aria_label_textarea: 'Enter your prompt here',
    disabled_empty_input: 'disabled, input is empty',
    disabled_streaming: 'disabled, response is streaming',
    disabled_awaiting_response: 'disabled, awaiting response',
    disabled_too_long: 'disabled, message is too long',
    disabled_not_connected: 'disabled, not connected',
  },
  prompt: {
    default_submit_text: 'Submit',
    aria_label_suggestion_prefix: 'Use suggestion: ',
    aria_label_textarea: 'Describe your requirements',
    suggestions_help_text:
      'Select one of the following suggestions to fill the input field:',
  },
  conversation: {
    conversation_label: 'AI Conversation',
    chat_history_label: 'Chat history',
    reply_placeholder: 'Type your message...',
    send_button_text: 'Send',
    ai_response_label: 'AI response',
    user_message_label: 'Your message',
    ai_typing_label: 'AI is typing',
    tool_call_message: 'Tool call message',
  },
  callout: {
    link_aria_label: '%{label} - opens in new tab',
  },
  purchase_data: {
    title: 'In-store purchase data',
    definition:
      'Share of in-store loyalty member purchases we could link to what was bought, by location and month.',
    empty: "We haven't linked any in-store purchases to the items bought yet.",
    error: "We couldn't load the in-store purchase data.",
    retry: 'Try again',
    table: {
      location: 'Location',
      all_locations: 'All locations',
      month_so_far: '%{month} (so far)',
      partial_month_note:
        "%{month} isn't over yet, so its numbers will still change.",
      no_purchases: '—',
      no_purchases_label: 'No purchases',
    },
  },
  help_links: {
    aria_label_resources: 'Help resources',
    aria_label_documentation: 'Help documentation',
    aria_label_link_suffix: ' - opens in new tab',
  },
  segment_name_modal: {
    title: 'Name your segment',
    subtitle: 'Give your segment a name so you can reference it later.',
    input_label: 'Segment name',
    input_placeholder: '',
    go_back_button: 'Go back',
    save_button: 'Save',
    validation_error: 'Segment name cannot be empty',
    validation_error_duplicate: 'Segment name already exists',
    validation_error_api_failure:
      'Unable to verify segment name uniqueness. Please try again.',
    preference_banner_auto_approve:
      'This segment will be activated immediately based on your saved settings.',
    preference_banner_review:
      'This segment will be submitted for Thanx review based on your saved settings.',
    preference_banner_change: 'Change',
  },
  segment_activation_modal: {
    title: 'Activate your segment',
    subtitle: 'Choose how this segment goes live',
    activation_method_aria_label: 'Activation method',
    option_review_title: 'Submit for Thanx review',
    option_review_subtitle:
      'Your segment will be reviewed by Thanx before going live to ensure accuracy and performance.',
    option_activate_title: 'Activate immediately',
    option_activate_subtitle:
      'You have reviewed this segment and are comfortable using without Thanx review.',
    remember_checkbox:
      'Always activate immediately (you can change this any time).',
    save_button: 'Save',
    cancel_button: 'Cancel',
  },
  segment_visualization: {
    raw_dsl_summary: 'View Raw DSL',
    raw_dsl_no_data: 'No DSL available',
    segment_created: '✅ Segment created successfully',
    parse_error: 'Error parsing segment data',
    no_description: 'No description provided',
    untitled_segment: 'Untitled Segment',
    submit_button: 'Save segment',
    saving_button: 'Saving...',
    auth_error: 'Authentication failed',
    streaming_timeout_error:
      'The request timed out. The service may be temporarily unavailable. Please try again in a moment.',
    view_in_admin: 'View in Admin',
    create_another_segment: 'Create another segment',
    create_campaign: 'Create a campaign',
    view_segment: 'View segment',
    loading: 'Loading...',
  },
  websocket_connection: {
    connection_failed: 'Connection failed',
    connection_error: 'Connection error',
    connection_lost_message:
      "I'm having trouble connecting right now. Please check your internet connection.",
    connection_restored_message: "Great! I'm back online and ready to help.",
  },
  picker: {
    no_matches: 'No matches found',
    group_header: {
      fallback_before: 'Must include',
      fallback_after: 'of the following %{label}(s)',
    },
    canonical: {
      card_title: '%{label} %{number}',
      remove_card: 'Delete %{title}',
      confirm: 'Confirm',
      items: {
        add: '+ Add item',
        select: 'Search for item name',
        select_many: 'Search for item names',
        search_versions: 'Search for item name or UID',
        select_first: 'Please select an item first',
        select_matched_first: 'Please select an item from your catalog first',
        pick_specific: 'Pick specific UIDs instead',
        // Searched item UIDs that don't carry the picked modifier
        out_of_scope: 'Not on these items',
        scope_error:
          "We couldn't load every item these UIDs belong to, so some modifiers may be missing.",
      },
      modifiers: {
        add: '+ Add modifier',
        select: 'Search for modifier name',
        select_many: 'Search for modifier names',
        search_versions: 'Search for modifier name or UID',
        select_first: 'Please select a modifier first',
        select_matched_first:
          'Please select a modifier from your catalog first',
        pick_specific: 'Pick specific UIDs instead',
        // Searched modifier UIDs the picked item doesn't carry
        out_of_scope: 'Not under this item',
        scope_error:
          "We couldn't load every modifier these UIDs belong to, so some items may be missing.",
      },
      smart: {
        label: 'Smart grouping',
        description: 'Every UID of the product, now and as menus change.',
      },
      specific: {
        label: 'Fixed list',
        description:
          'Only the UIDs you pick count. New menu items and locations are not added.',
      },
      manual_notice: {
        body: "This list won't update itself after menu changes.",
        action: 'Use smart grouping instead',
      },
      switch_to_smart: {
        title: 'Switch to smart grouping?',
        description:
          'Your fixed list will be replaced by the smart grouping, which keeps itself current as your menu changes. The specific UIDs you picked will be discarded.',
        confirm: 'Use smart grouping',
        cancel: 'Keep my fixed list',
      },
      selected_count: '%{count} selected',
      locations_count: '%{count} location',
      locations_count_plural: '%{count} locations',
      page_info: '%{first} - %{last} of %{total}',
      page_info_empty: '0 of 0',
      rows_error: "We couldn't load the options.",
      names_error: "We couldn't load the names of these picks.",
      switch_error: "We couldn't load the UIDs of this pick.",
      switch_without_versions:
        'No UIDs found for %{names}, so this level stays on smart grouping.',
      retry: 'Try again',
      no_uid_matches: 'No matches in your catalog.',
      too_large:
        'This selection is too large to send. Pick fewer UIDs, or use smart grouping.',
      versions: {
        link: "See what's inside",
        title: "What's inside",
        mode_smart: 'New UIDs for these products are added automatically.',
        mode_specific:
          'Only the UIDs below count. New menu items or locations will not be added.',
        locations_warning:
          'These picks count at every location that sells them. To limit the segment to some locations, ask the assistant.',
        caption: 'Every UID inside your selection',
        columns: {
          provider: 'Provider',
          name: 'Name',
          uid: 'UID',
          price: 'Price',
          locations: 'Location(s)',
        },
        price_range: '%{min} - %{max}',
        no_price: 'No price',
        locations_count: '%{count} location',
        locations_count_plural: '%{count} locations',
        row_toggle: 'Store UIDs of %{name}',
        product_empty: 'No UIDs on your menu right now',
        unmatched_section: 'UIDs added anyway',
        loading: 'Loading UIDs',
        error: "We couldn't load the UIDs in this selection.",
        locations_error: "We couldn't load your location names.",
        done: 'Done',
      },
      paste: {
        chip: '%{count} UID pasted',
        chip_plural: '%{count} UIDs pasted',
        clear: 'Clear pasted UIDs',
        checking: 'Looking up %{count} UID',
        checking_plural: 'Looking up %{count} UIDs',
        failed: "We couldn't look up these UIDs.",
        capped:
          'Only the first %{checked} of %{pasted} UIDs were looked up. Paste the rest separately.',
        not_found: 'Not found: %{uid}',
        add: 'Add UID',
        add_label: 'Add %{uid}',
        add_all: 'Add all',
        added: 'Added',
        add_anyway_warning: 'A UID that matches nothing targets nothing.',
      },
      unmatched: {
        badge: 'No match',
        level_warning:
          '%{count} UID you added matches nothing in your catalog and will target nothing.',
        level_warning_plural:
          '%{count} UIDs you added match nothing in your catalog and will target nothing.',
      },
      // Between a row's provider, UID and where it sells; the row spaces it
      row_separator: '·',
      // A location the merchant's list doesn't hold is named by its id
      location: {
        by_id: 'Location %{id}',
        unavailable: 'Location unavailable',
        none: 'No location',
      },
      global: {
        uid_label: 'Global UID',
        description:
          'A global UID also covers store UIDs mapped to it in the future, so picking every store UID under it is not the same.',
      },
      store_uids: {
        toggle: 'Store UIDs of %{name}',
        loading: 'Loading the store UIDs of %{name}',
        error: "We couldn't load the store UIDs of %{name}.",
        empty: 'None of its store UIDs sell at the locations you can see.',
      },
      footer: {
        specific:
          'Paste UIDs to find several at once. Your picks apply at every location that sells them; to limit the segment to some locations, ask the assistant after confirming.',
      },
    },
  },
}
